import mod from "-!./controller.js?vue&type=script&lang=js&"; export default mod; export * from "-!./controller.js?vue&type=script&lang=js&"